import { SetStateAction, useState } from "react";
import { useForm } from "react-hook-form";
import { CadastrarEmailContaContoller } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";
import { IEmailConta } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailContaInterface";
import { ModalCadastratEmailPropsInterface } from "../EmailConta";
import CreatableSelect from "react-select/creatable";

export default function ModalCadastrarEmailConta(
    props: ModalCadastratEmailPropsInterface
) {
    const [showPass, setShowPass] = useState<boolean>(false);
    const { register, handleSubmit, formState, reset } = useForm();

    const [copiaCarbono, setCopiaCarbono] = useState<Array<string> | undefined>(
        []
    );

    const [copiaCarbonoOculta, setCopiaCarbonoOculta] = useState<
        Array<string> | undefined
    >([]);

    const onSubmit = (formData: IEmailConta) => {
        CadastrarEmailContaContoller({
            ...formData,
            DS_COPIA: copiaCarbono,
            DS_COPIA_OCULTA: copiaCarbonoOculta,
        }).then((res) => {
            props.setShow(false);
            reset();
            props.updateList();
        });
    };

    const optionsCopiaCarbono = [
        {
            label: "",
            value: "",
        },
    ]?.filter((option) => option.value !== "");

    const optionsCopiaCarbonoOculta = [
        {
            label: "",
            value: "",
        },
    ]?.filter((option) => option.value !== "");

    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    return (
        <>
            <div className="text-center mb-10 mb-lg-20 ">
                <h2 className="font-weight-bold">Cadastro de E-mail</h2>
                <p className="text-muted font-weight-bold">
                    Preencha os dados da conta do e-mail
                </p>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className="form-group border-bottom py-3 b-5 col-12 ">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_USERNAME && "is-invalid"
                        }`}
                        type="email"
                        placeholder="E-mail"
                        name="DS_USERNAME"
                        ref={register({
                            required: "Insira o e-mail do usuário",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_USERNAME
                            ? formState.errors.DS_USERNAME.message
                            : ""}
                    </div>
                </div>
                <div className="form-group border-bottom py-3 b-5 col-12">
                    <div className="input-group">
                        <input
                            className={`form-control colomun h-auto border-0 mr-4 px-0 placeholder-dark-75 ${
                                formState.errors.DS_SENHA && "is-invalid"
                            }`}
                            type={!!showPass ? `text` : `password`}
                            placeholder="Senha"
                            name="DS_SENHA"
                            id="DS_SENHA"
                            ref={register({
                                required: true,
                            })}
                        />
                        <div
                            id="password"
                            className="input-group-append pt-7"
                            onMouseEnter={() => {
                                setShowPass(true);
                            }}
                            onMouseOut={() => {
                                setShowPass(false);
                            }}
                        >
                            <i
                                className={
                                    !!showPass
                                        ? `fas fa-eye`
                                        : `fas fa-eye-slash`
                                }
                                style={{
                                    fontSize: 17,
                                    padding: 0,
                                    color: "black",
                                }}
                                onMouseEnter={() => {
                                    setShowPass(true);
                                }}
                                onMouseOut={() => {
                                    setShowPass(false);
                                }}
                            ></i>
                        </div>
                    </div>
                    <div className="invalid-feedback">
                        {formState.errors.DS_SENHA
                            ? formState.errors.DS_SENHA.message
                            : ""}
                    </div>
                </div>
                <div className="form-group d-flex justify-content-between p-0 col-12">
                    <div className="form-group border-bottom py-3 b-0 col-8">
                        <input
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.DS_HOSTNAME_SMTP &&
                                "is-invalid"
                            }`}
                            type="text"
                            placeholder="Host SMTP"
                            name="DS_HOSTNAME_SMTP"
                            ref={register({
                                required: "Insira o Host SMTP",
                            })}
                            autoComplete="off"
                        />
                        <div className="invalid-feedback">
                            {formState.errors.DS_HOSTNAME_SMTP
                                ? formState.errors.DS_HOSTNAME_SMTP.message
                                : ""}
                        </div>
                    </div>

                    <div className="form-group border-bottom py-3 b-5 col-3 ">
                        <input
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.NR_PORTA_SMTP && "is-invalid"
                            }`}
                            type="text"
                            placeholder="SMTP"
                            name="NR_PORTA_SMTP"
                            ref={register({
                                required: "Porta SMTP",
                            })}
                            autoComplete="off"
                        />
                        <div className="invalid-feedback">
                            {formState.errors.NR_PORTA_SMTP
                                ? formState.errors.NR_PORTA_SMTP.message
                                : ""}
                        </div>
                    </div>
                </div>
                <div className="form-group d-flex justify-content-between p-0 col-12">
                    <div className="form-group border-bottom py-3 b-5 col-8">
                        <input
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.DS_HOSTNAME_IMAP &&
                                "is-invalid"
                            }`}
                            type="text"
                            placeholder="Host IMAP"
                            name="DS_HOSTNAME_IMAP"
                            ref={register({
                                required: "Insira o Host IMAP",
                            })}
                            autoComplete="off"
                        />
                        <div className="invalid-feedback">
                            {formState.errors.DS_HOSTNAME_IMAP
                                ? formState.errors.DS_HOSTNAME_IMAP.message
                                : ""}
                        </div>
                    </div>

                    <div className="form-group border-bottom py-3 b-5 col-3 ">
                        <input
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.NR_PORTA_IMAP && "is-invalid"
                            }`}
                            type="text"
                            placeholder="IMAP"
                            name="NR_PORTA_IMAP"
                            ref={register({
                                required: "Porta IMAP",
                            })}
                            autoComplete="off"
                        />
                        <div className="invalid-feedback">
                            {formState.errors.NR_PORTA_IMAP
                                ? formState.errors.NR_PORTA_IMAP.message
                                : ""}
                        </div>
                    </div>
                </div>

                <div className="form-group border-bottom py-3 b-5  col-12">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_REMETENTE && "is-invalid"
                        }`}
                        type="email"
                        placeholder="Remetente"
                        name="DS_REMETENTE"
                        ref={register({
                            required: "Insira o e-mail do remetente",
                        })}
                        autoComplete="off"
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_REMETENTE
                            ? formState.errors.DS_REMETENTE.message
                            : ""}
                    </div>
                </div>

                <div className="form-group border-bottom py-3 b-5  col-12">
                    <label>Cópia Carbono</label>
                    <CreatableSelect
                        isMulti
                        isClearable
                        isSearchable
                        onChange={(e) => {
                            setCopiaCarbono(
                                e.map(
                                    (value) => value?.value
                                ) as SetStateAction<string[] | undefined>
                            );
                        }}
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_COPIA && "is-invalid"
                        }`}
                        formatCreateLabel={(value) =>
                            `Clique para selecionar: ${value}`
                        }
                        styles={customStyles}
                        placeholder={"Digite o email"}
                        options={optionsCopiaCarbono}
                    />
                </div>
                <div className="form-group border-bottom py-3 b-5  col-12">
                    <label>Cópia Carbono Oculta</label>
                    <CreatableSelect
                        isMulti
                        isClearable
                        isSearchable
                        onChange={(e) => {
                            setCopiaCarbonoOculta(
                                e.map(
                                    (value) => value?.value
                                ) as SetStateAction<string[] | undefined>
                            );
                        }}
                        className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                            formState.errors.DS_COPIA_OCULTA && "is-invalid"
                        }`}
                        formatCreateLabel={(value) =>
                            `Clique para selecionar: ${value}`
                        }
                        styles={customStyles}
                        placeholder={"Digite o email"}
                        options={optionsCopiaCarbonoOculta}
                    />
                </div>

                <div className="form-row mb-5">
                    <div className="col-12 d-flex flex-column align-itens-center justify-content-center">
                        <div className="text-center font-weight-bold">
                            Certificado SLL:
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_SSL"
                                    name="FL_SSL"
                                    defaultChecked={false}
                                    ref={register()}
                                    type="checkbox"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-center align-items-center">
                    <button
                        type="submit"
                        id="kt_login_signin_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                    >
                        Cadastrar
                    </button>
                </div>
            </form>
        </>
    );
}
